"use client";

import { productsSchema } from "../../../lib/types/schema/subscription/productSchema";
import { useRequestQuery } from "../../../request/hooks/useRequestQuery";
import { keyPlans } from "./keyProducts";

export const useRequestProducts = () => {
  return {
    query: useRequestQuery({
      queryFnRequestProps: {
        schema: productsSchema,
        urlBackendPath: "/products/plans",
      },
      queryKey: keyPlans(),
    }),
  };
};
